import React from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import blogimg from "../assets/blog.jpeg";
import { Api2 } from "../pages/blog/Api";

const BlogPost = ({ post }) => {

  return (
    <div className="d-flex my-3 blogcontent">
      <div className="blogimg">
        {!post.featured_media ? (
          <img src={blogimg} className="w-100 h-100" alt="blog image" />
        ) : (
          <img
            src={post._embedded["wp:featuredmedia"][0].source_url}
            className="w-100 h-100"
            alt="blog image"
          />
        )}
      </div>
      <div className="mt-1">
        <h5 className="font-normal text-black-fade mt-1">
          {post._embedded["wp:term"][0][0].name}
        </h5>
        <Link to={`/blog/${post.id}`} className="lh-small font-heading text-black my-2 d-inline-block">
          {post.title.rendered}
        </Link>
        <p className="font-medium font-weight-bolder">
          {post.date.slice(0, 10)}
        </p>
      </div>
    </div>
  );
};

export default BlogPost;
